import { Stack } from 'expo-router';

const IndividualLayout = () => {
  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerShadowVisible: false,
        headerBackVisible: false
      }}>
      <Stack.Screen name="index" />
      <Stack.Screen
        name="impact"
        options={{
          headerShown: false
        }}
      />
      <Stack.Screen name="edit" />
    </Stack>
  );
};

export default IndividualLayout;
